import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-scroll';
const NavBar = () => {

    const [nav, setNav] = useState(false);

    const links = [
        {
            id: 1,
            link: 'home'
        },
        {
            id: 2,
            link: 'about'
        },
        {
            id: 3,
            link: 'projects'
        },
        {
            id: 4,
            link: 'experience'
        },
        {
            id: 5,
            link: 'contact'
        }
    ];

    return (
        // Total Nav Div
        <div className='z-10 flex justify-between items-center w-full h-20 px-4 text-white bg-black fixed'>
            {/* For logo */}
            <div>
                <Link
                    to='home'
                    smooth
                    duration={500}
                    className='text-4xl font-signature font ml-2 cursor-pointer'
                >
                    Mainuddin
                </Link>
            </div>
            {/* Simple Nav Menu */}
            <ul className='hidden md:flex'>
                {links.map(({ id, link }) => (
                    <li
                        key={id}
                        className="px-4 cursor-pointer capitalize font-medium text-gray-400 
                        hover:scale-105 duration-200"
                    >
                        <Link
                            to={link}
                            smooth
                            duration={500}
                            offset={-70}
                        >
                            {link}
                        </Link>
                    </li>
                ))}
            </ul>
            {/* for hambarger and cross toggle button */}
            <div
                onClick={() => setNav(!nav)}
                className='cursor-pointer pr-4 z-10 text-gray-500 md:hidden'
            >
                {nav ? <FaTimes size={20} /> : <FaBars size={20} />}
            </div>
            {/* Dropdown Nav Menu for mobile view */}
            {nav && (
                <ul className='flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen 
                bg-gradient-to-b from-black to-gray-800 text-gray-400'
                >
                    {links.map(({ id, link }) => (
                        <li
                            key={id}
                            className='px-4 cursor-pointer capitalize py-3 text-2xl '
                        >
                            <Link
                                onClick={() => setNav(!nav)}
                                to={link}
                                smooth
                                duration={500}
                                offset={-70}
                            >
                                {link}
                            </Link>

                        </li>
                    ))}
                </ul>
            )}

        </div>
    )
}

export default NavBar;